import {WorkflowNodeData, WorkflowNodeTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const talkNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.TALK,
  data: {
    type: WorkflowNodeTypes.TALK,
    settingsTitle: "Talk Settings",
    description: "This is the talk node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [],
  },
  position: {x: 0, y: 0},
};
